import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { SafeMethodCall } from '@angular/compiler';

@Injectable({
  providedIn: 'root',
})

export class HttpService {
  tokens
  allAllergData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  allDietData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  allAllergDataAll: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  allDietDataAll: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  dishes: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  orderIdvalue: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  loginShetRef:any
  constructor(private http: HttpClient) { }
  token = sessionStorage.getItem('access_token')
  quiz_identity = sessionStorage.getItem('quiz_identity')
  allergenceArray = []
  diestPrefArray = []
  spiceTollerence: any = null
  showPrefChoseFlag = true
  restoBranchCurrentId = null
  // httpOptions1 = { 
  //   headers: new HttpHeaders({

  //     Authorization:'Bearer ' + this.token
  //   })
  // };
  PassedObject(passData) {
    this.dishes.next(passData);

  }
  storePassedObject(passedData) {
    this.allAllergData.next(passedData);

  }
  storePassedDietObject(passDiet) {

    this.allDietData.next(passDiet)

  }

  storePassedAllAllergence(passAllergenceAll) {
    this.allAllergDataAll.next(passAllergenceAll)
  }
  storePassedAllDiet(passAllDietAll) {
    this.allDietDataAll.next(passAllDietAll)
  }
  // here instead of reterieve like this you can directly subscribe the property in your compoents
  retrievePassedObject() {
    return this.allAllergData;
  }

  retrievePassedDietObject() {
    return this.allDietData;

  }

  retrievePassedObjectAll() {
    return this.allAllergDataAll;
  }

  retrievePassedDietObjectAll() {
    return this.allDietDataAll;

  }

  logouts(token) {
    const data = {
      token: token
    }
    return this.http.post(environment.serverUrl + 'logout', data);

  }
  logout() { }
  getData(source: string) {
    return this.http.get(source).pipe(
      tap((res: any) => res),
      catchError(this.handleError)
    );
  }//https://test.iglulabs.com/foodbud_apis/www/api/guest/allAllergens
  getReturant(id) {
    // return this.http.get(environment.baseUrl + 'allAllergens');
  }
  // 

  getallAllergens() {
    // return this.http.get(environment.baseUrl + 'allAllergens');
  }
  getallDiestpref() {
    return this.http.get(environment.baseUrl + 'alldp');
  }


  getuserallAllergens() {
    return this.http.get(environment.userbaseUrl + 'allAllergens');
  }
  getuserallDiestpref() {
    return this.http.get(environment.userbaseUrl + 'alldp');
  }



  getallCategory() {
    return this.http.get(environment.baseUrl + 'category');
  }
  getTag() {
    return this.http.get(environment.baseUrl + 'tagList');
  }
  getReturantDetails(id) {
    return this.http.get(environment.baseUrl + 'restaurantAllDishes?id=' + id);
  }

  getUserIngredientDetails(id, restoID) {
    return this.http.get(environment.userbaseUrl + 'ingredents?restaurant_id=' + restoID + '&dish_id=' + id);
  }

  getIngredientDetails(id, restoID) {
    return this.http.get(environment.baseUrl + 'ingredents?restaurant_id=' + restoID + '&dish_id=' + id);
  }
  deleteDish(id, restaurant_id) {
    const data = {
      dish_id: id,
      id: restaurant_id,
      status: "Deleted"
    }
    return this.http.put(environment.baseUrl + 'dishStatusChange', data);
  }
  updateList(data) {

    return this.http.put(environment.baseUrl + 'updateRestaurantDish', data);
  }

  showmenu(obj) {
    return this.http.post(environment.baseUrl + 'getDishList', obj);
  }

  getAllMenuLabels(id){
    return this.http.get(environment.restaturantUrl + "restaurantMenuNames?id=" + id)
  }

  addOwnMenu(id){
    return this.http.get(environment.restaturantUrl + "addOwnMenu?id=" + id );
  }


  activs
  showmenuGet(value, allergens_id, dietry_preferences) {
    this.activs = {
      restaurant_id: value,
      allergens_id: allergens_id,
      dietry_preferences: dietry_preferences,
      spice_rating_all: sessionStorage.getItem("spiceRating"),
      cross_contamination: sessionStorage.getItem("guestCC") ? sessionStorage.getItem("guestCC") : "No"
    }
    return this.http.post(environment.baseUrl + 'foodDishes', this.activs);
  }
  userCC
  showmenuUserGet(value, allergens_id, dietry_preferences) {
    this.activs = {
      restaurant_id: value,
      allergens_id: allergens_id,
      dietry_preferences: dietry_preferences,
      spice_rating_all: sessionStorage.getItem("spiceRating") ? sessionStorage.getItem("spiceRating") : 0,
      cross_contamination: sessionStorage.getItem("UserCC")

    }
    return this.http.post(environment.userbaseUrl + 'foodDishes', this.activs);
  }


  showmenuOrder(value, dishesh) {
    this.activs = {
      restaurant_id: value,
      dishes: dishesh,
    }
    return this.http.post(environment.baseUrl + 'totalPrice', this.activs);
  }

  restaurant_offline_guest(lat, lng): Observable<any> {
    return this.http.get(environment.baseUrl + 'restaurantAll?lat=' + lat + '&long=' + lng)
  }
  restaurant_offline_user(lat, lng): Observable<any> {
    return this.http.get(environment.userbaseUrl + 'restaurantAll?lat=' + lat + '&long=' + lng)
  }
  restaurant_online(): Observable<any> {
    return this.http.get(environment.baseUrl + 'restaurantAllOnline')
  }

  showmenuOrderget(value, dishesh) {
    this.activs = {
      restaurant_id: value,
      dishes: dishesh,
    }
    return this.http.post(environment.userbaseUrl + 'totalPrice', this.activs);
  }

  addFavlist(value, dish_id) {
    this.activs = {
      restaurant_id: value,
      dish_id: dish_id,
    }
    return this.http.post(environment.userbaseUrl + 'favorite', this.activs);
  }
  deleteFav(id) {
    const data = { "favorite_id": id }
    return this.http.put(environment.userbaseUrl + 'favorite', data);
  }
  addList(id, data) {
    let formatData = new FormData();
    formatData.append('file', data);
    formatData.append('id', id);
    return this.http.post(environment.baseUrl + 'dishUpload', formatData);
  }

  addImage(data) {
    return this.http.post(environment.baseUrl + 'uploadDishImage', data);
  }
  getCsvTempData() {
    return this.http.get(environment.baseUrl + 'dishFormat');
  }

  private handleError(error: any) {
    return observableThrowError(error.error || 'Server error');
  }
  postUserPreference(data) {
    return this.http.post(environment.userbaseUrl + 'userPreference', data);
  }
  getUserPreference() {
    return this.http.get(environment.userbaseUrl + 'userPreference');
  }
  postCustomizedFoodDishes(data) {
    return this.http.post(environment.userbaseUrl + 'foodDishes', data);
  }
  updateUserPreference(data) {
    return this.http.put(environment.userbaseUrl + 'cc', data);
  }


  allActiveAllergens(id) {
    return this.http.get(environment.baseUrl + 'restaurantAllergence?restaurant_id=' + id)
  }


  allActiveDietary(id) {
    return this.http.get(environment.baseUrl + 'restaurantDietary?restaurant_id=' + id)
  }


  ///get table data///
  getTableData(id, table_id) {
    return this.http.get(environment.baseUrl + 'restaurant?id=' + id + '&table_id=' + table_id)
  }



  getReturantValue(id) {
    return this.http.get(environment.baseUrl + 'restaurant?id=' + id);
  }

  ////display the dishs///
  GetDishType(id) {
    return this.http.get(environment.baseUrl + 'restaurantDishType?restaurant_id=' + id)
  }
  ////display dishType with menu///
  dummyCC = "No"
  customizedDishes(value, allergens_id, dietry_preferences, name) {

    this.activs = {
      restaurant_id: value,
      allergens_id: allergens_id,
      dietry_preferences: dietry_preferences,
      spice_rating_all: sessionStorage.getItem("spiceRating") ? sessionStorage.getItem("spiceRating") : 0,
      cross_contamination: sessionStorage.getItem("guestCC") ? sessionStorage.getItem("guestCC") : this.dummyCC,
      dish_type_name: name
    }

    return this.http.post(environment.baseUrl + 'foodDishesByType', this.activs);
  }

  customizedDishesUser(value, allergens_id, dietry_preferences, name) {
    this.activs = {
      restaurant_id: value,
      allergens_id: allergens_id,
      dietry_preferences: dietry_preferences,
      spice_rating_all: sessionStorage.getItem("spiceRating") ? sessionStorage.getItem("spiceRating") : 0,
      cross_contamination: sessionStorage.getItem("guestCC") ? sessionStorage.getItem("guestCC") : this.dummyCC,
      dish_type_name: name
    }
    return this.http.post(environment.userbaseUrl + 'foodDishesByType', this.activs);
  }

  //////Place order api for Guest////
  orderItemdata
  GuestDineinOrder(id, orderDishes, allAllergDatas, allDietDatas, spiceRating,
    value, tableID) {
    this.orderItemdata = {
      order_restaurant_id: id,
      order_dishes: orderDishes,
      order_allergens: allAllergDatas,
      order_dietery: allDietDatas,
      order_overall_spice: spiceRating,
      order_cc: sessionStorage.getItem("guestCC") ? sessionStorage.getItem("guestCC") : this.dummyCC,
      order_name: value,
      table_id: tableID
    }
    return this.http.post(environment.baseUrl + 'dineOrder', this.orderItemdata)
  }

  ///order for Guest sighin////
  loginOrderdata
  guestOrderDineInUserLogin(Formvalue, restoID, orderItem, allAllergDatas, allDietDatas,
    tableID) {
    this.loginOrderdata = {
      username: Formvalue.login,
      password: Formvalue.pass,
      order_restaurant_id: restoID,
      order_dishes: orderItem,
      order_allergens: allAllergDatas,
      order_dietery: allDietDatas,
      order_overall_spice: sessionStorage.getItem("spiceRating") ? sessionStorage.getItem("spiceRating") : 0,
      order_cc: sessionStorage.getItem("guestCC") ? sessionStorage.getItem("guestCC") : this.dummyCC,
      table_id: tableID
    }
    return this.http.post(environment.baseUrl + 'guestOrderDineInUserLogin', this.loginOrderdata)
  }
  ////overrideDineInOrder///
  overrideData
  overrideDineInOrder(restoID, orderItem, allAllergDatas, allDietDatas,
    tableID) {
    this.overrideData = {
      order_restaurant_id: restoID,
      order_dishes: orderItem,
      order_allergens: allAllergDatas,
      order_dietery: allDietDatas,
      order_overall_spice: sessionStorage.getItem("spiceRating") ? sessionStorage.getItem("spiceRating") : 0,
      order_cc: sessionStorage.getItem("guestCC") ? sessionStorage.getItem("guestCC") : this.dummyCC,
      table_id: tableID
    }
    return this.http.post(environment.userbaseUrl + 'overrideDineInOrder', this.overrideData)
  }


  ////User Dine in///
  usersdineindata
  UserDineinOrder(id, tableid, orderdishes) {
    this.usersdineindata = {
      order_restaurant_id: id,
      table_id: tableid,
      order_dishes: orderdishes
    }
    return this.http.post(environment.userbaseUrl + 'DineInOrder', this.usersdineindata)
  }

  // order historydisplay api////
  userOrderData
  orderHistorydata() {
    this.userOrderData = {
      order_status: ["Pending", "Verified", "Accepted", "Cooking", "Ready"]
    }
    return this.http.post(environment.userbaseUrl + 'allOrder', this.userOrderData)
  }

  userOrderCompletedData
  orderHistoryCompleteddata() {
    this.userOrderCompletedData = {
      order_status: ["Completed", "Cancelled"]
    }
    return this.http.post(environment.userbaseUrl + 'allOrder', this.userOrderCompletedData)
  }

  singleUserOrderhistory(orderId) {
    return this.http.get(environment.userbaseUrl + 'order?order_id=' + orderId)
  }


  /////Reviews API///
  ///get review for allergens//
  allergensOrderReviewCheck(orderID, dishID) {
    return this.http.get(environment.userbaseUrl + 'allergensOrderReviewCheck?order_id=' + orderID + '&dish_id=' + dishID)
  }
  /// post review///
  postReview(orderId, dishId, restoId, orderItemId, starvalue, tastecomment, allAllergReviewvalue, allergenscomment) {
    const data = {
      order_id: orderId,
      dish_id: dishId,
      restaurant_id: restoId,
      order_item_id: orderItemId,
      test_score_code: starvalue,
      test_score_text: tastecomment,
      alleregens_rating_code: allAllergReviewvalue,
      alleregens_rating_text: allergenscomment
    }
    return this.http.post(environment.userbaseUrl + 'review', data)
  }

  /////post review dishwish///
  postreviewDishWise(id, restoID) {
    const reviewData = {
      restaurant_id: restoID,
      dish_id: id
    }
    return this.http.post(environment.userbaseUrl + 'reviewDishWise', reviewData)
  }

  ///post guest review dishwish///
  guestpostreviewDishwise(dishId, restoID, allAllergDatas, allDietDatas) {
    const guestreviewData = {
      restaurant_id: restoID,
      dish_id: dishId,
      allergens: allAllergDatas,
      dietary: allDietDatas
    }
    return this.http.post(environment.baseUrl + 'reviewDishWise', guestreviewData)
  }

  /// user get all order Reviews///
  getallReviews(id, dishId) {
    return this.http.get(environment.userbaseUrl + 'allReview?restaurant_id=' + id + '&dish_id=' + dishId)
  }

  ///  user get All allergens Review//
  getAllergensReview(id, dishid) {
    return this.http.get(environment.userbaseUrl + 'allAllergenReview?restaurant_id=' + id + '&dish_id=' + dishid)
  }

  ///Guest get allergens review///
  guestgetAllergensReview(id, dishid) {
    return this.http.get(environment.baseUrl + 'allAllergenReview?restaurant_id=' + id + '&dish_id=' + dishid)
  }

  ///Guest get all order Review///
  guestgetallReviews(id, dishId) {
    return this.http.get(environment.baseUrl + 'allReview?restaurant_id=' + id + '&dish_id=' + dishId)
  }

  ///getuserallergens dropdown//
  userreviewAllergenDishWise(id, dishid, allergensid) {
    return this.http.get(environment.userbaseUrl + 'reviewAllergenDishWise?restaurant_id=' + id + '&dish_id=' + dishid + '&allergen_id=' + allergensid)
  }


  ///get guestallergens dropdown///
  guestreviewAllergenDishWise(id, dishid, allergensid) {
    return this.http.get(environment.baseUrl + 'reviewAllergenDishWise?restaurant_id=' + id + '&dish_id=' + dishid + '&allergen_id=' + allergensid)
  }

  // passId(orderId){
  // this.orderIdvalue.next(orderId);
  // }
  guestSingleorderDetail(id) {
    return this.http.get(environment.baseUrl + 'order?order_id=' + id)
  }
  ////User Details////
  userProfile() {
    return this.http.get(environment.userbaseUrl + 'userProfile')
  }

  userProfileDetails() {
    return this.http.get(environment.userbaseUrl + 'userProfileDetail')
  }

  updateuserImage(data) {
    return this.http.post(environment.userbaseUrl + 'uploadUserImage', data)
  }

  updateUserProfile(up_fname, up_lname, up_phone, up_gender, up_address, feet, up_inch) {
    let data = {
      fname: up_fname,
      lname: up_lname,
      phone: up_phone,
      gender: up_gender,
      address: up_address,
      feet: feet,
      inch: up_inch
    }
    return this.http.post(environment.userbaseUrl + 'userProfile', data)
  }

  ////get Ingredients///
  ingredients() {
    return this.http.get(environment.userbaseUrl + 'ingredients')
  }


  ///////foodPreferences////
  foodPreferences(allergensarry, dietPref, ingredientbind, user_preference_spice, userDislikesbind) {
    let food_items = {
      allergens: allergensarry,
      dietary: dietPref,
      ingredients: ingredientbind,
      spice: user_preference_spice,
      dislikes: userDislikesbind
    }
    return this.http.post(environment.userbaseUrl + 'foodPreferences', food_items)

  }
  ////get foodpreferences///
  getfoodPreferences() {
    return this.http.get(environment.userbaseUrl + 'foodPreferences')
  }

  ///get ingredients///
  getIngredients() {
    return this.http.get(environment.userbaseUrl + 'ingredients')
  }

  ////usergetdishdetails///
  getuserdishDetail(dishid, id) {
    return this.http.get(environment.userbaseUrl + 'dishDetail?dish_id=' + dishid + '&restaurant_id=' + id)
  }

  ////guestgetdishdetails///
  guestgetdishDetail(dishid, id) {
    return this.http.get(environment.baseUrl + 'dishDetail?dish_id=' + dishid + '&restaurant_id=' + id)
  }


  ////quiz api ///
  tasteDetailsput(data) {
    return this.http.put(environment.userbaseUrl + 'tasteDetails', data)
  }
  tasteDetailsget() {
    return this.http.get(environment.userbaseUrl + 'tasteDetails')
  }
  validAuthToken() {
    return this.http.get(environment.userbaseUrl + 'validAuthToken')
  }
  //////referal code social share /////
  shareCodeGet() {
    return this.http.get(environment.userbaseUrl + 'shareCode')
  }

  decodeShareCode(data: any) {
    return this.http.post(environment.userbaseUrl + 'decodeShareCode', data)
  }

  friends() {
    return this.http.get(environment.userbaseUrl + 'friends')
  }
  ////resto descr///
  restaurantDescUser(id) {
    return this.http.get(environment.userbaseUrl + 'restaurantDesc?id=' + id)
  }
  restaurantDescGuest(id) {
    return this.http.get(environment.baseUrl + 'restaurantDesc?id=' + id)
  }
  deletefriends(id) {
    let data = {
      friend_id: id
    }
    return this.http.put(environment.userbaseUrl + 'removeFriend', data)
  }
  resto_note_update(id, note) {
    let data = {
      restaurant_id: id,
      restaurant_notes: note
    }
    return this.http.put(environment.userbaseUrl + 'notes', data)
  }

  restaurant_note_get(value) {
    return this.http.get(environment.userbaseUrl + 'notes?restaurant_id=' + value)
  }


  restoALL_Location_user(lat, long) {
    return this.http.get(environment.userbaseUrl + 'restaurantAll?lat=' + lat + '&long=' + long)
  }
  restoALL_Location_guest(lat, long) {
    return this.http.get(environment.baseUrl + 'restaurantAll?lat=' + lat + '&long=' + long)
  }
  recordLocation_guest(restoId, lat, lng, visitor_origin) {
    let data = {
      visitorLat: lat,
      visitorLang: lng,
      restaurant_id: restoId,
      visitorOrigin: visitor_origin
    }
    return this.http.post(environment.baseUrl + 'recordLocation', data)
  }

  recordLocation_user(restoId, lat, lng, visitor_origin) {
    let data = {
      visitorLat: lat,
      visitorLang: lng,
      restaurant_id: restoId,
      visitorOrigin: visitor_origin
    }
    return this.http.post(environment.userbaseUrl + 'recordLocation', data)
  }

  recordDestination_user(id, address) {
    let data = {
      restaurant_id: id,
      restaurant_map_destination_name: address
    }
    return this.http.post(environment.userbaseUrl + 'recordDestination', data)
  }

  recordDestination_guest(id, address) {
    let data = {
      restaurant_id: id,
      restaurant_map_destination_name: address
    }
    return this.http.post(environment.baseUrl + 'recordDestination', data)
  }

  guest_Getoptions(dishid, restoid) {
    return this.http.get(environment.baseUrl + 'dishDetail?restaurant_id=' + restoid + '&dish_id=' + dishid)
  }

  user_Getoptions(dishid, restoid) {
    return this.http.get(environment.userbaseUrl + 'dishDetail?restaurant_id=' + restoid + '&dish_id=' + dishid)
  }

  user_dishAddOnList(restoID, dish_ID, quantity, food_dishes_option_id) {
    let data = {
      restaurant_id: restoID,
      dish_id: dish_ID,
      quantity: quantity,
      option_id: food_dishes_option_id
    }
    return this.http.post(environment.userbaseUrl + 'dishAddOnList', data)
  }

  dishAddOnList(restoID, dish_ID, quantity, food_dishes_option_id,
    allAllergDatas, allDietDatas) {
    let data = {
      restaurant_id: restoID,
      dish_id: dish_ID,
      quantity: quantity,
      option_id: food_dishes_option_id,
      allergens_id: allAllergDatas,
      dietry_preferences: allDietDatas
    }
    return this.http.post(environment.baseUrl + 'dishAddOnList', data)
  }

  calculatePrice(restoId, dishId, optionId, quantity, rdaoop_id) {
    let data = {
      restaurant_id: restoId,
      dish_id: dishId,
      quantity: quantity,
      option_id: optionId,
      rdaoop_id: rdaoop_id
    }
    return this.http.post(environment.baseUrl + 'calculatePrice', data)
  }

  user_calculatePrice(restoId, dishId, optionId, quantity, rdaoop_id) {
    let data = {
      restaurant_id: restoId,
      dish_id: dishId,
      quantity: quantity,
      option_id: optionId,
      rdaoop_id: rdaoop_id
    }
    return this.http.post(environment.userbaseUrl + 'calculatePrice', data)
  }

  userIngridientLike(status, name) {
    let data = {
      name: name,
      status: status
    }
    return this.http.put(environment.userbaseUrl + 'userIngridientLike', data)
  }
  userIngridientDisLike(status, name) {
    let data = {
      name: name,
      status: status
    }
    return this.http.put(environment.userbaseUrl + 'userIngridientDisLike', data)
  }

  // Integrated by prakash for new PWA

  sendOtpByEmail(email) {
    let data = {
      email: email
    }
    return this.http.post(environment.serverUrl + 'sendOtpByEmail', data)
  }
  verifyOTPUser(data: any) {
    return this.http.post(environment.serverUrl + 'verifyOtp', data)
  }

  myCart() {
    return this.http.get(environment.mainUrl + 'myCart');
  }

  addToCart(data) {
    return this.http.post(environment.mainUrl + 'addToCart', data)
  }

  placeOrder(data) {
    return this.http.post(environment.mainUrl + 'placeAnOrder', data)
  }

  updateProfile(data) {
    return this.http.post(environment.profileUrl + 'updateProfile', data);
  }

  getDishDetailsForAddon(restoId, dishId) {
    return this.http.get(environment.mainUrl + 'getDishDetail?restaurant_id=' + restoId + '&dish_id=' + dishId)
  }

  postAddonDetails(data) {
    return this.http.post(environment.mainUrl + 'getAddonDtlsBasedOptionId', data);
  }

  getAllCategories() {
    return this.http.get(environment.baseUrl + 'allCategory');
  }

  getAllOfflineRestaurants(lat, long) {
    return this.http.get(environment.baseUrl + 'getOfflineRestaurant?lat=' + lat + '&long=' + long);
  }

  getAllCuisines() {
    return this.http.get(environment.baseUrl + 'allCuisine');
  }

  getAllFilteredCategories(lat, long, categoryId) {
    return this.http.get(environment.baseUrl + 'getOfflineRestaurant?lat=' + lat + '&long=' + long + '&category_id=' + categoryId)
  }

  getAllFilteredCuisine(lat, long, cuisineId) {
    return this.http.get(environment.baseUrl + 'getOfflineRestaurant?lat=' + lat + '&long=' + long + '&cuisine_id=' + cuisineId)
  }

  getFilteredCusine(cuisineId) {
    return this.http.get(environment.baseUrl + 'getOfflineRestaurant?cuisine_id=' + cuisineId)
  }

  getFilteredCategories(categoryId) {
    return this.http.get(environment.baseUrl + 'getOfflineRestaurant?category_id=' + categoryId)
  }

  getRestoWithoutLocation() {
    return this.http.get(environment.baseUrl + 'getOfflineRestaurant')
  }

  getOrderDetails(OrderId) {
    return this.http.get(environment.mainUrl + 'orderDetails?order_id=' + OrderId);
  }

  placeOrderWithPayment(data) {
    return this.http.post(environment.mainUrl + 'placeAnOrderWithPayment', data)
  }

  getRestaurantAllergens(restoId) {
    return this.http.get(environment.baseUrl + 'getRestaurantallAllergens?restaurant_id=' + restoId)
  }
  getRestaurantAllergensWithoutId() {
    return this.http.get(environment.baseUrl + 'getRestaurantallAllergens')
  }

  getRestaurantDietray(restoId) {
    return this.http.get(environment.baseUrl + 'getRestaurantDietary?restaurant_id=' + restoId)
  }
  getRestaurantDietrayWithoutId() {
    return this.http.get(environment.baseUrl + 'getRestaurantDietary')
  }
  getHideSpiceTolleranceCheck(restoId) {
    return this.http.get(environment.baseUrl + 'getRestaurantSpiceActive?restaurant_id=' + restoId)
  }
  
  getDislikesAndFavorites() {
    return this.http.get(environment.mainUrl + 'getAllSubIngredients');
  }

  postUserPreferences(data) {
    return this.http.post(environment.mainUrl + 'postUserPreference', data)
  }

  getUserPreferences() {
    return this.http.get(environment.mainUrl + 'getUserPreference');
  }

  getReviewDishWise(restoId, dishId) {
    return this.http.get(environment.mainUrl + 'reviewDishWise?restaurant_id=' + restoId + '&dish_id=' + dishId);
  }

  getTasteReviewsBasedOnDishId(restoId, dishId) {
    return this.http.get(environment.mainUrl + 'allTasteReview?restaurant_id=' + restoId + '&dish_id=' + dishId)
  }

  getAllergyReviewBasedonDishId(restoId, dishId) {
    return this.http.get(environment.mainUrl + 'allAllergenReview?restaurant_id=' + restoId + '&dish_id=' + dishId);
  }

  postDishReviews(data) {
    return this.http.post(environment.mainUrl + 'submitReviewFromMenu', data)
  }

  getAllPlacedOrders(obj) {
    return this.http.post(environment.mainUrl + 'getAllOrders', obj);
  }

  postUserReviews(data) {
    return this.http.post(environment.mainUrl + 'postReview', data);
  }

  getAllDishInfo(restoId, dishId) {
    return this.http.get(environment.mainUrl + 'getDishAllInfo?restaurant_id=' + restoId + '&dish_id=' + dishId);
  }

  getDishIngredients(restoId, dishId) {
    return this.http.get(environment.mainUrl + 'getDishIngredents?restaurant_id=' + restoId + '&dish_id=' + dishId);
  }

  postLikeDish(data) {
    return this.http.put(environment.mainUrl + 'updateUserIngridientLike', data)
  }

  postDisLikesDish(data) {
    return this.http.put(environment.mainUrl + 'updateUserIngridientDisLike', data);
  }
  getAllRestoByMutiCat(data) {
    return this.http.post(environment.multiCat + 'getAllRestaurantList', data)
  }
  getUserAllDeatails() {
    return this.http.get(environment.userbaseUrl + 'userProfileDetail')
  }
  updateUsersProfileDeatails(data) {
    return this.http.post(environment.userbaseurlV2 + 'updateUserProfile', data)

  }
  getUserAllDeatailsFromOther() {
    return this.http.get(environment.userbaseurlV2 + 'userDetails')
  }
  getDishWiseAllergens(dish_id: any) {
    return this.http.get(environment.userbaseUrl + 'allAllergensByDishIdUserId?dish_id=' + dish_id)
  }
  getCategoryWiseAllergenChart(resto_id: any, dish_type_name: any) {
    const params = new HttpParams()
      .set('restaurant_id', resto_id)
      .set('dish_type_name', dish_type_name);
  
    return this.http.get(`${environment.userbaseUrl}userAllergensChart`, { params });
  }
  getUnsuitableData(dish_id:any){
    return this.http.get(environment.baseUrl + 'userUnsuitableData?dish_id=' + dish_id)
  }
}
